import React, { Component } from 'react';
import Nprogress from 'nprogress';
import ReactPlaceholder from 'react-placeholder';
import 'nprogress/nprogress.css';
import 'react-placeholder/lib/reactPlaceholder.css';

export default function asyncComponent(importComponent) {
  class AsyncFunc extends Component {
    constructor(props) {
      super(props);
      this.state = {
        component: null,
        loadError: null,
      };
    }
    componentWillMount() {
      Nprogress.start();
    }
    componentWillUnmount() {
      this.mounted = false;
    }
    async componentDidMount() {
      this.mounted = true;
      try {
        const { default: Comp } = await importComponent();
        if (this.mounted) {
          this.setState({
            component: <Comp {...this.props} />,
            loadError: null,
          });
        }
      } catch (err) {
        console.error('AsyncFunc: dynamic import failed', err);
        if (this.mounted) {
          this.setState({
            loadError: err.message || 'Failed to load page',
          });
        }
      } finally {
        Nprogress.done();
      }
    }

    render() {
      const { component, loadError } = this.state;
      if (loadError) {
        return (
          <div style={{ padding: 24 }}>
            โหลดหน้าไม่สำเร็จ: {loadError}
          </div>
        );
      }
      return (
        <ReactPlaceholder type="text" rows={7} ready={component !== null}>
          {component || <div />}
        </ReactPlaceholder>
      );
    }
  }
  return AsyncFunc;
}
